import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useCustomerUpdatesDialogStyles = makeStyles({
    dialogSurface: {
        maxWidth: 'min(600px, calc(100% - 20px))',
        maxHeight: 'calc(100vh - 100px)',
    },
    dialogBody: {
        maxHeight: 'calc(100vh - 148px)',
    },
    dialogTitle: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '10px',
    },
    dialogTitleIcon: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '40px',
        height: '40px',
        borderRadius: '3px',
        backgroundColor: tokens.colorBrandBackgroundStatic,
    },
    dialogTitleCustomerSection: {
        wordBreak: 'break-word',
        overflowWrap: 'anywhere',
    },
    dialogTitleCustomerName: {
        textTransform: 'uppercase',
        fontWeight: 'bold',
        fontSize: tokens.fontSizeBase300,
    },
    dialogTitleCustomerInfo: {
        display: 'flex',
        flexDirection: 'row',
        fontSize: tokens.fontSizeBase300,
        gap: '10px',
    },
    dialogContent: {
        padding: '0px 12px',
        margin: '0px, -12px',
    },
    dialogSubform: {
        margin: '10px 0px',
    },
    actions: {
        padding: '10px 0px 0px',
        margin: '0px 0px',
    },
});

export const useContentSkeletonStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        height: '100%',
    },
    item: {
        minHeight: '150px',
    },
});

export const useCustomerUpdatesDialogContentStyles = makeStyles({
    content: {
        padding: '8px 16px',
        margin: '0 0 10px',
        border: '1px solid',
        borderRadius: '8px',
        ...shorthands.borderColor(tokens.colorNeutralStroke1),
    },
});
